/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerUpdateVisibilityMutationRequest, ProjectsControllerUpdateVisibilityMutationResponse, ProjectsControllerUpdateVisibilityPathParams, ProjectsControllerUpdateVisibility400, ProjectsControllerUpdateVisibility401, ProjectsControllerUpdateVisibility403, ProjectsControllerUpdateVisibility404 } from "../../models/projectsController/ProjectsControllerUpdateVisibility";

function getProjectsControllerUpdateVisibilityUrl(id: ProjectsControllerUpdateVisibilityPathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/projects/${id}/visibility` as const }  
  return res
}

/**
 * @summary Update project visibility
 * {@link /api/v1/projects/:id/visibility}
 */
export async function projectsControllerUpdateVisibility(id: ProjectsControllerUpdateVisibilityPathParams["id"], data?: ProjectsControllerUpdateVisibilityMutationRequest, config: Partial<RequestConfig<ProjectsControllerUpdateVisibilityMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsControllerUpdateVisibilityMutationResponse, ResponseErrorConfig<ProjectsControllerUpdateVisibility400 | ProjectsControllerUpdateVisibility401 | ProjectsControllerUpdateVisibility403 | ProjectsControllerUpdateVisibility404>, ProjectsControllerUpdateVisibilityMutationRequest>({ method : "PATCH", url : getProjectsControllerUpdateVisibilityUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}